/**
 * Okabe-Ito: picked to stay distinguishable under the common forms of color
 * blindness, and spread in lightness so regions differ by more than hue.
 */
export const REGION_PALETTE = [
  "#E69F00",
  "#56B4E9",
  "#009E73",
  "#F0E442",
  "#0072B2",
  "#D55E00",
  "#CC79A7",
];
